<template>
  <div v-cloak>
    <div class="vx-card" id="inventory-item">
      <div class="vx-card__body card-body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div class="vx-row" v-if="showFilters">
          <div class="vx-col w-full">
            <form class="vx-row">
              <div class="vx-col lg:w-2/3 w-full">
                <div class="vx-col w-full">
                  <div class="w-full">
                    <vs-input
                      class="inputx"
                      v-model="gridSearchData.name"
                      :label="$t('ProductName')"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-5 vx-col lg:w-1/3 w-full">
                <div class="vx-col w-full">
                  <vs-button
                    type="filled"
                    class="float-right"
                    @click.prevent="submitFilter()"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                  <vs-button
                    type="filled"
                    class="float-right ml-4"
                    id="reset-btn"
                    @click.prevent="resetForm"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="vx-row pt-6">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                {
                  title: $t('StatusDetermination'),
                  sort: 'StatusDetermination',
                },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('ModelNumber'), sort: 'ModelNumber' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 40%" :title="row.stockName">
                  {{ row.name | truncate(75) }}
                </td>
                <td style="width: 20%">
                  <span v-if="row.stockType == 0">
                    <button class="type-btn" @click="measurableBtn(row.id)">
                      {{ $t("Measurable") }}
                    </button>
                    <button class="type-btn2" @click="serializeBtn(row.id)">
                      {{ $t("Serialize") }}
                    </button>
                  </span>
                  <span v-if="row.stockType == 1">
                    {{ $t("Serialize") }}
                  </span>
                  <span v-if="row.stockType == 2">
                    {{ $t("Measurable") }}
                  </span>
                </td>
                <td style="width: 12%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 12%">
                  {{ row.modelNumber }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
export default {
  name: "warehouseManagement_Products_WaitingStatus",
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "/Inventory/api/StockQuery",
      },
      gridSearchData: {
        isStockTypeDetermined: "false",
      },
      model: {
        stockId: null,
        stockType: null,
      },
      showFilters: false,
    };
  },
  methods: {
    ...mapActions({
      updateStock: "stock/update",
    }),
    measurableBtn(id) {
      this.model = {
        stockId: id,
        stockType: 2,
      };
      this.$swal({
        title: "آیا از تخصیص این وضعیت اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.updateStock(this.model).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 3000);
          });
        }
      });
    },
    serializeBtn(id) {
      this.model = {
        stockId: id,
        stockType: 1,
      };
      this.$swal({
        title: "آیا از تخصیص این وضعیت اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.updateStock(this.model).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 3000);
          });
        }
      });
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        name: "",
        isStockTypeDetermined: "false",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
